import React from 'react';

const Snacks = () => {
  return <div>Snacks</div>
}

export default Snacks;
